import { render, staticRenderFns } from "./FormalizacionActasInfo.vue?vue&type=template&id=74164158"
import script from "./FormalizacionActasInfo.vue?vue&type=script&lang=js"
export * from "./FormalizacionActasInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74164158')) {
      api.createRecord('74164158', component.options)
    } else {
      api.reload('74164158', component.options)
    }
    module.hot.accept("./FormalizacionActasInfo.vue?vue&type=template&id=74164158", function () {
      api.rerender('74164158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/info_procesos/FormalizacionActasInfo.vue"
export default component.exports